import React from "react";
import { connect } from "react-redux";
import TemplateLabel from "../TemplateLabel";
import TemplateHint from "../TemplateHint";
import { makeStyles } from "@material-ui/core";

const useStylesMedia = makeStyles((theme) => ({
    button:props =>(
        {
            width:"100%",
            background:props.backgroundColor,
            color:"var(--accent-color) !important",
            textAlign:"center",
            cursor: "pointer",
            fontWeight: 700,
            textTransform: "uppercase"
        }
    ),
    icon:props =>({
        backgroundColor: props.backgroundColor,
        borderRadius: "50%",
        color: "var(--accent-color) !important",
        boxShadow: "rgb(51, 51, 51) 0px 7px 6px -6px",
        cursor: "pointer",
        float: "right",
        position: "relative"
    })
}))
const TemplateMediaControl = (props ) => {
    let backgroundColor = props.appearance.match(new RegExp(/<#(.*?)\/>/), 'g');
    backgroundColor = backgroundColor !== null ? `#${backgroundColor[1]}` : "var(--primary-color)"; 
    const styleProps = { backgroundColor: backgroundColor};
    const classes = useStylesMedia(styleProps)
    if(props.appearance.indexOf('inline')>-1){
        let icon = 'fa-camera'
        switch (props.type){
            case 'audio':
                icon = 'fa-microphone'
                break
            case 'video':
                icon = 'fa-video'
                break

            default:
                icon = 'fa-camera'
                break

        }
            
        return (
            <div>
                <div className="inline-wrapper d-flex flex-wrap justify-content-between">
                    {
                        props.appearance.indexOf("text-nolabel") === -1 &&
                        <div
                            className="flex-shrink-1 flex-grow-1  order-1"
                            style={{ flexBasis: "0%" }}
                        >
                            <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
                        </div>
                    }
                    <div style={{ order: 2, marginLeft: "1rem" }}>
                    <label className={"btn btn-circle btn-icon tf-btn-sm "+ classes.icon}>
                        <i className={"fa-solid "+icon}></i>
                    </label>
                    </div>
                </div>
                <div>
                    <TemplateHint hint={props["hint::"+props.language]}/>
                </div>

            </div>
        )
    }
    return (
        <>
            {
                props.appearance.indexOf("text-nolabel") === -1 &&
                <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
            }
            
            <TemplateHint hint={props["hint::"+props.language]}/>
            <div>
                {
                    <label className={"form-control " +classes.button}>
                        {props.type == 'image' ? 'TAKE PICTURE' : 'Record ' + props.type}
                    </label>
                }
                <label className={"form-control " +classes.button}>
                    {'CHOOSE ' + props.type} 
                </label>
            </div>
        </>
    )
};

const mapStateToProps = (state, props) => {
    return {
        ...props,
        display : state['questionsList'][props.questionId].display,
        required: state['questionsList'][props.questionId].required,
        readonly:  state['questionsList'][props.questionId].readonly,
        appearance: state['questionsList'][props.questionId].appearance,
        ["label::"+props.language] : state['questionsList'][props.questionId]["label::"+props.language],
        ["hint::"+props.language] : state['questionsList'][props.questionId]["hint::"+props.language],
        type:state['questionsList'][props.questionId].type
    };
}
export default connect(mapStateToProps)(TemplateMediaControl);
